import {
  Box,
  Button,
  Stack,
  Typography
} from "@mui/material";
import MaterialModal from "../../app/material-modal";
import { useKeycloak } from "@react-keycloak/web";
import { useQueryClient } from "@tanstack/react-query";
import { useDeleteRole } from "../../../tanstackQuery/queries/superAdmin/roles";
import { toast } from "sonner";

export function RemoveFromGroupModal({ open, handleClose, cohortTypeLabel,roleID }) {
    const { keycloak } = useKeycloak();
    const client = useQueryClient();
    
    const {
      mutateAsync: deleteRole,
      isPending,
      isSuccess,
    } = useDeleteRole(
      { accessToken: keycloak?.token },
      {
        onSuccess: () => {
          client.invalidateQueries({ queryKey: ["orgtree"] });
          if(cohortTypeLabel==="Organisation"){
            client.invalidateQueries({ queryKey: ["orgUserList"] });
          }
          else if(cohortTypeLabel==="Cohort"){
            client.invalidateQueries({ queryKey: ["orgCohortUsertDetails"] });
          }
          else if(cohortTypeLabel==="Team"){
            client.invalidateQueries({ queryKey: ["orgCohortTeamUserDetails"] });
          }

          handleClose();
        },
      }
    );
  
    const deleteRoleFromGroup = async () => {
        const newTeamData = {
            roleID
        };
        try {
          await deleteRole(newTeamData);
          if (isSuccess) {
            toast.success("Role successfully deleted!");
            handleClose();
          }
        } catch (error) {
          toast.error(error?.response?.data?.message || "Failed to delete role.");
        }
     };

  return (
    <MaterialModal
      open={open}
      handleDialogClose={handleClose}
      title="Are you sure?"
    >
      <Box>
        <Typography fontSize="15px">
          Are you sure you want to remove this user from {cohortTypeLabel} ?
        </Typography>

        <Stack direction="row" spacing={1} mt={3} justifyContent="end">
          <Button variant="outlined" size="medium" onClick={handleClose}>
            No
          </Button>
          <Button disabled={isPending} variant="contained" size="medium" onClick={deleteRoleFromGroup}>
            Yes
          </Button>
        </Stack>
      </Box>
    </MaterialModal>
  );
}
